import { Chip } from '@dentalux/ui-library-core/cjs'

import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Chips = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
}))

export const DentalChips = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.highlight2.main,
}))
